var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M2.32812 9.9987C2.32812 6.856 2.32812 5.28465 3.30444 4.30834C4.28075 3.33203 5.85209 3.33203 8.99479 3.33203H12.3281C15.4708 3.33203 17.0422 3.33203 18.0185 4.30834C18.9948 5.28465 18.9948 6.856 18.9948 9.9987C18.9948 13.1414 18.9948 14.7127 18.0185 15.6891C17.0422 16.6654 15.4708 16.6654 12.3281 16.6654H8.99479C5.85209 16.6654 4.28075 16.6654 3.30444 15.6891C2.32812 14.7127 2.32812 13.1414 2.32812 9.9987Z",
    stroke: "#EFEFFD",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.66406 6.66797L7.46314 8.1672C8.99367 9.44264 9.75894 10.0804 10.6641 10.0804C11.5692 10.0804 12.3345 9.44264 13.865 8.1672L15.6641 6.66797",
    stroke: "#EFEFFD",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.4519fa400b346166919fa48dd3bf9c42.svg";
export { ForwardRef as ReactComponent };